export default __webpack_public_path__ + "static/media/logo.afd30c1e.png";